import _ from 'lodash'
import {getUsedFonts} from '@/utils/useStylesheet'

const WebFont = require('webfontloader')

const state = () => ({
  fonts: ['ABeeZee', 'Abel', 'Aclonica', 'Acme', 'Actor', 'Adamina', 'Akronim', 'Aladin', 'Aldrich', 'Alef', 'Alegreya', 'Alice', 'Alike', 'Allan', 'Allerta', 'Allura', 'Almendra', 'Amarante', 'Amaranth', 'Amethysta', 'Amiri', 'Amita', 'Anaheim', 'Andada', 'Andika', 'Angkor', 'Antic', 'Anton', 'Arapey', 'Arbutus', 'Arimo', 'Arizonia', 'Armata', 'Artifika', 'Arvo', 'Arya', 'Asap', 'Asar', 'Asset', 'Astloch', 'Asul', 'Aubrey', 'Audiowide', 'Average', 'Balthazar', 'Bangers', 'Basic', 'Battambang', 'Baumans', 'Bayon', 'Belgrano', 'Belleza', 'BenchNine', 'Bentham', 'Bevan', 'Bilbo', 'Biryani', 'Bitter', 'Bokor', 'Bonbon', 'Boogaloo', 'Brawler', 'Buda', 'Buenard', 'Butcherman', 'Cabin', 'Cagliostro', 'Calligraffitti', 'Cambay', 'Cambo', 'Candal', 'Cantarell', 'Capriola', 'Cardo', 'Carme', 'Caudex', 'Chango', 'Chewy', 'Chicle', 'Chivo', 'Cinzel', 'Coda', 'Codystar', 'Combo', 'Comfortaa', 'Condiment', 'Convergence', 'Cookie', 'Copse', 'Corben', 'Courgette', 'Cousine', 'Coustard', 'Creepster', 'Crushed', 'Cuprum', 'Cutive', 'Damion', 'Dekko', 'Delius', 'Devonshire', 'Dhurjati', 'Diplomata', 'Domine', 'Dorsa', 'Dosis', 'Dynalight', 'Eater', 'Economica', 'Eczar', 'Electrolize', 'Elsie', 'Engagement', 'Englebert', 'Enriqueta', 'Esteban', 'Ewert', 'Exo', 'Fira Sans', 'Fascinate', 'Federant', 'Federo', 'Felipa', 'Fenix', 'Flamenco', 'Flavors', 'Fondamento', 'Forum', 'Fresca', 'Frijole', 'Fruktur', 'Great Vibes', 'Gabriela', 'Gafata', 'Galdeano', 'Galindo', 'Geo', 'Geostar', 'Gidugu', 'Glegoo', 'Gorditas', 'Graduate', 'Griffy', 'Gruppo', 'Gudea', 'Gurajada', 'Habibi', 'Halant', 'Hanalei', 'Handlee', 'Hind', 'Homenaje', 'Iceberg', 'Iceland', 'Imprima', 'Inconsolata', 'Inder', 'Inika', 'Italiana', 'Italianno', 'Just Another Hand', 'Jaldi', 'Judson', 'Julee', 'Junge', 'Jura', 'Kadwa', 'Kalam', 'Kameron', 'Karla', 'Karma', 'Kavoon', 'Kenia', 'Khand', 'Khula', 'Knewave', 'Kranky', 'Kreon', 'Kristi', 'Kurale', 'League Spartan', 'Laila', 'Lancelot', 'Lateef', 'Lato', 'Ledger', 'Lekton', 'Lemon', 'Limelight', 'Lobster', 'Lora', 'Lusitana', 'Lustria', 'Macondo', 'Magra', 'Mako', 'Mallanna', 'Mandali', 'Marcellus', 'Margarine', 'Marmelad', 'Martel', 'Marvel', 'Mate', 'McLaren', 'Meddon', 'MedievalSharp', 'Megrim', 'Merienda', 'Merriweather', 'Metamorphous', 'Metrophobic', 'Michroma', 'Milonga', 'Miltonian', 'Miniver', 'Modak', 'Molengo', 'Monda', 'Monofett', 'Monoton', 'Montaga', 'Montez', 'Montserrat', 'Muli', 'NTR', 'Neucha', 'Neuton', 'Niconne', 'Nobile', 'Norican', 'Nosifer', 'Numans', 'Nunito', 'Open Sans', 'Offside', 'Oldenburg', 'Oranienbaum', 'Orbitron', 'Oregano', 'Orienta', 'Oswald', 'Overlock', 'Ovo', 'Oxygen', 'PT Sans', 'Permanent Marker', 'Pacifico', 'Palanquin', 'Paprika', 'Parisienne', 'Peddana', 'Peralta', 'Petrona', 'Philosopher', 'Piedra', 'Plaster', 'Play', 'Playball', 'Podkova', 'Poly', 'Pompiere', 'Poppins', 'Prata', 'Prociono', 'Puritan', 'Quando', 'Quantico', 'Quattrocento', 'Questrial', 'Quicksand', 'Quintessential', 'Qwigley', 'Radley', 'Rajdhani', 'Raleway', 'Ramabhadra', 'Ramaraja', 'Rambla', 'Ranchers', 'Rancho', 'Ranga', 'Rationale', 'Redressed', 'Revalia', 'Ribeye', 'Righteous', 'Risque', 'Roboto', 'Rochester', 'Rokkitt', 'Romanesco', 'Rosario', 'Rosarivo', 'Rubik', 'Ruda', 'Rufina', 'Ruluko', 'Ruthie', 'Rye', 'Sacramento', 'Sahitya', 'Sail', 'Salsa', 'Sanchez', 'Sancreek', 'Sarala', 'Sarina', 'Sarpanch', 'Satisfy', 'Scada', 'Scheherazade', 'Schoolbell', 'Sevillana', 'Shanti', 'Share', 'Shojumaru', 'Signika', 'Simonetta', 'Sintony', 'Skranji', 'Slackey', 'Smokum', 'Smythe', 'Sniglet', 'Snippet', 'Sofia', 'Spinnaker', 'Spirax', 'Stalemate', 'Stoke', 'Strait', 'Sumana', 'Sunshiney', 'Sura', 'Suranna', 'Suravaram', 'Syncopate', 'Tangerine', 'Tauri', 'Teko', 'Telex', 'Tienne', 'Tillana', 'Timmana', 'Tinos', 'Trocchi', 'Trochut', 'Trykker', 'Ubuntu', 'Ultra', 'Underdog', 'UnifrakturCook', 'UnifrakturMaguntia', 'Unkempt', 'Unlock', 'Unna', 'VT323', 'Varela', 'Vibur', 'Vidaloka', 'Viga', 'Voces', 'Volkhov', 'Vollkorn', 'Voltaire', 'Wallpoet', 'Warnes', 'Wellfleet', 'Yantramanav', 'Yellowtail', 'Yesteryear', 'Zeyada'],
  allGoogleFonts: [],
  allCustomFonts: [],
  allCustomFontsFromCSS: [],
  editableGoogleFont: false,
  editableCustomFont: false,
  customFontsCSS: ''
})

const minify = (text) => {
  return text.replace(/([^0-9a-zA-Z.#])\s+/g, '$1')
    .replace(/\s([^0-9a-zA-Z.#]+)/g, '$1')
    .replace(/;}/g, '}')
    .replace(/\/\*.*?\*\//g, '')
}

const cssFontFacesToList = (css) => {
  const faces = css.match(/@font-face\s*{[^}]+}/g) || []
  const map = new Map()

  faces.forEach(face => {
    const fam = (face.match(/font-family:\s*['"]([^'"]+)['"]/i) || [])[1] || ''
    let w = ((face.match(/font-weight:\s*([^;}\s]+)/i) || [])[1] || '400').toLowerCase()

    // normalize keywords → numeric
    if (w === 'normal') w = '400'
    if (w === 'bold')   w = '700'
    const weight = (w.match(/\d+/) || ['400'])[0]

    if (!fam) return
    if (!map.has(fam)) map.set(fam, new Set())
    map.get(fam).add(weight)
  })

  return Array.from(map.entries()).map(([family, weights]) => ({
    family,
    variants: Array.from(weights).sort((a, b) => parseInt(a) - parseInt(b))
  }))
}

const getters = {}

const actions = {
  async fontsArrayToString ({state, rootState}, fonts) {
    const fontsClearArray = _.uniq(fonts)
      .filter(f => f !== null)
      .filter(f => f !== undefined)
      .filter(f => f !== '')

    const googleFonts = fontsClearArray
      .map(_font => {
        const font = rootState.editor.globalStyles.font.addedGoogleFonts.find(font => {
          return font.family.toLowerCase() === _font.toLowerCase()
        })

        if (font) {
          return font
        }
      })
      .filter(f => f !== undefined)
      .map(font => {
        return `family=${font.family}:wght@${_.sortBy(_.uniq(font.variants.map(variant => variant.toString()))).join(';')}&display=swap`
      })
      .join('&')
      .replaceAll(' ', '+')
    const customFonts = fontsClearArray.map(_font => {
      let font = state.allCustomFonts.find(group => group.font_name === _font)
      if (font) {
        return font
      }
    })
      .filter(f => f !== undefined)
      .map(font => {
        return `family=${font.font_name}`
      })
      .join('&')
      .replaceAll(' ', '+')

    return {
      googleFonts,
      customFonts
    }
  },
  async prepareFonts ({dispatch}) {
    return await new Promise((resolve) => {
      let fonts = getUsedFonts()
      let contentFonts = _.uniq([...document.querySelectorAll('spanec')].map(node => node.style.fontFamily.replaceAll('"','')))

      dispatch('fontsArrayToString', [...fonts, ...contentFonts])
        .then((data) => {
          return Promise.all([dispatch('fetchGoogleFontsCSS', data.googleFonts), dispatch('fetchCustomFontsCSS', data.customFonts)])
            .then((data) => {
              resolve({
                googleFonts: data[0],
                customFonts: data[1]
              })
            })
        })
    })
  },
  async prepareGlobalFonts ({dispatch}) {
    return await new Promise((resolve) => {
      let fonts = getUsedFonts('.--global--')


      dispatch('fontsArrayToString', [...fonts])
        .then((data) => {
          return Promise.all([dispatch('fetchGoogleFontsCSS', data.googleFonts), dispatch('fetchCustomFontsCSS', data.customFonts)])
            .then((data) => {
              resolve({
                googleFonts: data[0],
                customFonts: data[1]
              })
            })
        })
    })
  },
  getFontsFromJson (__, json) {
    const regex = new RegExp(/"fontFamily":"(.*?)"|"fontFamily":\{"lg":"(.*?)",/g)
    let fonts = [],
      result = []

    // eslint-disable-next-line no-cond-assign
    while (result = regex.exec(JSON.stringify(json))) {
      if (result[2] !== null) fonts.push(result[2])
      if (result[1] !== null) fonts.push(result[1])
    }

    return _.compact(_.uniq(fonts))
  },
  async fetchGoogleFontsCSS (_, fonts) {
    if (!fonts) return ''
    return await new Promise((resolve) => {
      fetch(`https://fonts.googleapis.com/css2?${fonts}`)
        .then((response) => {
          response.text().then((text) => {
            resolve(minify(text))
          })
        })
    })
  },
  async fetchCustomFontsCSS ({state, rootState}) {
    if (!rootState.projects.project) return

    const style = await axios.get(`api/site/${rootState.projects.project.subdomain}/custom-css`)
    state.customFontsCSS = style.data.data

    // Remove duplicate @font-face declarations
    const fontFaces = state.customFontsCSS.match(/@font-face\s*{[^}]+}/g) || []
    const uniqueFaces = _.uniqBy(fontFaces, face => {
      const family = (face.match(/font-family:\s*'([^']+)'/) || [])[1] || ''
      const style = (face.match(/font-style:\s*([^;]+)/) || [])[1] || ''
      const weight = (face.match(/font-weight:\s*([^;]+)/) || [])[1] || ''
      return `${family}_${style}_${weight}`
    })
    state.customFontsCSS = uniqueFaces.join(' ')
    state.allCustomFontsFromCSS = cssFontFacesToList(state.customFontsCSS)

    return state.customFontsCSS
  },
  async fetchGoogleFonts ({rootState, state, dispatch}) {
    VEvent.fire('loader', true)
    VEvent.fire('loader.message', 'Loading Google fonts, this may take a minute...')

    try {
      const cacheKey = 'google_fonts_cache'
      const cacheExpiryKey = 'google_fonts_cache_expiry'
      const cacheDuration = 24 * 60 * 60 * 1000
      const now = Date.now()

      const cachedFonts = localStorage.getItem(cacheKey)
      const cacheExpiry = localStorage.getItem(cacheExpiryKey)

      if (cachedFonts && cacheExpiry && now < cacheExpiry) {
        state.allGoogleFonts = JSON.parse(cachedFonts)
      } else {
        const response = await fetch(
          'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyAFEYyFKJh7D64KN994VANsCmDKjCryub0&fields=items.family,items.variants&sort=alpha'
        )
        const data = await response.json()

        state.allGoogleFonts = data.items.map((font) => ({
          family: font.family,
          variants: font.variants
            .filter((variant) => !variant.includes('italic'))
            .map((variant) => (variant === 'regular' ? '400' : variant))
        }))

        localStorage.setItem(cacheKey, JSON.stringify(state.allGoogleFonts))
        localStorage.setItem(cacheExpiryKey, now + cacheDuration)
      }

      await dispatch('loadFonts', rootState.editor.globalStyles.font.addedGoogleFonts)
    } catch (error) {
      console.error('Error fetching Google Fonts:', error)
    } finally {
      VEvent.fire('loader', false)
    }
  },
  loadFonts (_, fonts) {
    WebFont.load({
      google: {
        families: fonts.map(font => `${font.family}:${font.variants.join(',')}&display=swap`)
      }
    })
  },
  async fetchCustomFonts ({state, rootState}) {
    if (!rootState.projects.project) return
    state.editableCustomFont = false
    await axios.get(`api/projects/${rootState.projects.project.id}/fonts`)
      .then(({data}) => {
        state.allCustomFonts = data.data.map(font => {
          return {
            ...font,
            fonts: _.uniqBy(Array.isArray(font.fonts) ? font.fonts : [], item =>
              `${(item.font_style || '').toLowerCase()}_${item.font_weight || ''}`
            )
          }
        })
      })
  },
  fetchProjectFonts ({dispatch, rootState}) {
    WebFont.load({
      google: {
        families: rootState.editor.globalStyles.font.addedGoogleFonts.map(font => {
          return `${font.family}:${font.variants.join(',')}`
        })
      }
    })

    dispatch('fetchCustomFonts')
  },
  async deleteCustomFont ({rootState}, id) {
    await axios.delete(`api/projects/${rootState.projects.project.id}/fonts/${id}`)
  },
  updateGoogleFont ({dispatch, rootState}, payload) {
    const index = rootState.editor.globalStyles.font.addedGoogleFonts.findIndex(font => font.family === payload.family)
    if (index !== -1) {
      rootState.editor.globalStyles.font.addedGoogleFonts[index].variants = payload.variants
    }

    VEvent.fire('loader', true)

    dispatch('projects/save', {}, {root: true})
      .finally(() => {
        VEvent.fire('loader', false)
      })
  },
  async addGoogleFont ({dispatch, rootState}, payload) {
    return await new Promise((resolve) => {
      rootState.editor.globalStyles.font.addedGoogleFonts.push(payload)

      VEvent.fire('loader', true)

      dispatch('projects/save', {}, {root: true})
        .finally(() => {
          VEvent.fire('loader', false)
          resolve()
        })
      dispatch('loadFonts', [...rootState.editor.globalStyles.font.addedGoogleFonts, payload])
    })
  },
  removeGoogleFont ({dispatch, rootState, state}, payload) {
    rootState.editor.globalStyles.font.addedGoogleFonts.splice(rootState.editor.globalStyles.font.addedGoogleFonts.findIndex(font => font.family === payload), 1)
    state.editableGoogleFont = false

    VEvent.fire('loader', true)

    dispatch('projects/save', {}, {root: true})
      .finally(() => {
        VEvent.fire('loader', false)
      })
  },
  editGoogleFont ({rootState, state}, payload) {
    const index = rootState.editor.globalStyles.font.addedGoogleFonts.findIndex(font => font.family === payload)
    if (index !== -1) {
      return state.editableGoogleFont = index
    }

    state.editableGoogleFont = false
  },
  editCustomFont ({state}, payload) {
    if (payload !== false) {
      return state.editableCustomFont = state.allCustomFonts.find(group => group.id === payload)
    }

    state.editableCustomFont = false
  },
  updateCustomFont ({state}, payload) {
    if (payload !== -1) {
      return state.editableCustomFont = payload
    }

    state.editableCustomFont = false
  }
}

const mutations = {}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
